import { Flex, Tag, TagCloseButton, TagLabel, Text } from '@chakra-ui/react';
import { ColumnFilter } from '@tanstack/react-table';

import { FilterExtraInfo, findFilterById } from '../Filters';
import { FilterType } from '../NewFilterComponent';
import FilterValue from './FilterValue';

type Props<TData> = {
  columnFilters: ColumnFilter[];
  hiddenFilters?: (keyof TData)[];
  removeItemFunc: (item: ColumnFilter) => void;
  filterExtraInfo: FilterExtraInfo<TData>;
};

function ActiveFilters<TData>({
  columnFilters,
  hiddenFilters,
  removeItemFunc,
  filterExtraInfo,
}: Props<TData>) {
  return (
    <Flex gap={1}>
      {columnFilters.map((filter) => {
        if (hiddenFilters?.some((key) => filter.id === key)) {
          return null;
        }
        return (
          <Tag key={filter.id} bgColor="primary" color="white">
            <TagLabel display="flex">
              <Text>{filter.id}: </Text>
              <FilterValue
                value={filter.value}
                filterType={
                  findFilterById(filterExtraInfo, filter.id)?.filterType || FilterType.STRING
                }
              />
            </TagLabel>
            <TagCloseButton onClick={() => removeItemFunc(filter)} />
          </Tag>
        );
      })}
    </Flex>
  );
}

export default ActiveFilters;
